module.exports = __webpack_public_path__ + "static/media/reddy.b9e004a8.png";